import React, { Fragment, useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { connect } from 'react-redux'
import copyToClipboard from 'copy-to-clipboard'

import { checkoutTotalDiscounted, clear } from '@actions/checkout'
import { closeLoader, openLoader } from '@actions/loader.js'
import logo from './images/logo-pix.png'
import { Timer } from './Timer'
import { requestCheckPixPayment } from '@actions/checkPixPayment'
import { PIX_EXPIRATION_TIME, getExpirationSeconds } from '@utils/pix'

export const PixPaymentModalComponent = ({
  order: { order_id: orderId, pix_copy_paste: copyPaste, pix_qrcode: qrCode, pix_expiration: expiration },
  total,
  checkPayment: checkPaymentRequest,
  onClose,
  clearCheckout,
  openLoader,
  closeLoader,
}) => {
  const navigate = useNavigate()
  // ponte V2: no fluxo novo (flag) e em qualquer tela /v2 (ex.: conta) o modal ganha
  // o skin do design system, tamanho maior e saída explícita; o V1 permanece intacto
  const isV2 = sessionStorage.getItem('smd_v2_flow') === '1' || window.location.pathname.startsWith('/v2')
  const [show, setShow] = useState(false)
  const [wasCopied, setWasCopied] = useState(false)
  const [isCanceled, setIsCanceled] = useState(false)
  const expirationSeconds = expiration ? getExpirationSeconds(expiration.criacao) : PIX_EXPIRATION_TIME
  let interval = null
  if (!show) {
    openLoader()
  }

  const checkPayment = () => {
    checkPaymentRequest(orderId).then(({ payload: { message } }) => {
      if (message === 'Canceled') {
        setIsCanceled(true)
      } else if (message === 'Paid') {
        clearCheckout()
        clearInterval(interval)
        navigate(sessionStorage.getItem('smd_v2_flow') === '1' ? '/v2/steps/concluido' : '/steps/concluido', { replace: true })
      } else if (!show) {
        setShow(true)
        closeLoader()
      }
    })
  }

  checkPayment()

  useEffect(() => {
    interval = setInterval(checkPayment, 3000)
    return () => {
      clearInterval(interval)
    }
  })

  const copy = () => {
    copyToClipboard(copyPaste)
    setWasCopied(true)
  }

  return (
    <Modal show={show} className={isV2 ? 'pix-modal pix-modal--v2' : 'pix-modal'}>
      <Modal.Body>
        <div className="pix-content">
          {isV2 && !isCanceled && (
            <button type="button" id="pix-v2-close" className="pix-v2-close" aria-label="Fechar" onClick={onClose}>
              ×
            </button>
          )}
          <img className="pix-logo" src={logo} alt="Logo do PIX" />
          <Timer seconds={expirationSeconds} />
          {!isCanceled ? (
            <Fragment>
              <p>
                1. Acesse o app de seu banco ou o seu internet banking.
                <br />
                2. Escolha pagar via PIX.
                <br />
                3. Copie e cole a chave abaixo ou escaneie o QR code.
                <br />
                4. Realize o pagamento.
                <br />
                5. O pagamento será automaticamente confirmado.
              </p>
              <button className="pix-copy-paste" onClick={copy}>
                <span>{copyPaste}</span>
                <span>{wasCopied ? 'Copiado' : 'Copiar'}</span>
              </button>
              <span>OU</span>
              <img width="175" src={'data:image/png;base64, ' + qrCode} alt="QR code de pagamento" />
              {isV2 && (
                <Fragment>
                  <button type="button" id="pix-v2-cancel" className="pix-v2-cancel" onClick={onClose}>
                    Escolher outra forma de pagamento
                  </button>
                  <p className="pix-v2-note">
                    A chave gerada continua válida até expirar. Se você pagar por outra forma, ignore esta chave.
                  </p>
                </Fragment>
              )}
            </Fragment>
          ) : (
            <Fragment>
              <span>Chave expirada.</span>
              <p className="pix-expired-info">
                Seu pedido foi cancelado. Você poderá realizar um novo pedido escolhendo outra forma de pagamento ou
                gerando novamente uma chave PIX.
              </p>
              <button style={{ fontWeight: 600 }} className="button__small" onClick={onClose}>
                Fechar
              </button>
            </Fragment>
          )}
        </div>
      </Modal.Body>
      {!isCanceled && (
        <Modal.Footer>
          <span>Valor total:</span>
          <span>{total.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</span>
        </Modal.Footer>
      )}
    </Modal>
  )
}

const mapStateToProps = (state, ownProps) => ({
  total: ownProps.total || checkoutTotalDiscounted(state) + state.freight.calculated_freight,
  order: ownProps.order || state.creditCard,
})

const mapDispatchToProps = dispatch => ({
  checkPayment: data => dispatch(requestCheckPixPayment(data)),
  clearCheckout: () => dispatch(clear()),
  openLoader: () => dispatch(openLoader()),
  closeLoader: () => dispatch(closeLoader()),
})

export const PixPaymentModal = connect(mapStateToProps, mapDispatchToProps)(PixPaymentModalComponent)

